import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=1ff599ca&scoped=true&"
import script from "./RecipientForm.vue?vue&type=script&lang=js&"
export * from "./RecipientForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipientForm.vue?vue&type=style&index=0&id=1ff599ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff599ca",
  null
  
)

export default component.exports